import { Unauthorized } from "@app/shared/ErrorPages";
import { JSX, useContext, useEffect } from "react";
import { Redirect, Route, RouteComponentProps, Switch, useHistory } from "react-router-dom";
import { UserContext } from "@app/user/UserContext";
import Roles from "@app/user/roles";
import CreateExceptionsWizard from "@app/exceptions/CreateExceptionsWizard";
import ExceptionsHome from "@app/exceptions/ExceptionsHome";
import UploadExceptionsWizard from "@app/exceptions/UploadExceptionsWizard";
import { EXCEPTIONS_FILTERS_SESSION_KEY_ARCHIVED, EXCEPTIONS_FILTERS_SESSION_KEY_OVERVIEW, markExceptionsRouterActive, markExceptionsRouterInactive } from "@app/exceptions/contexts/ExceptionsFiltersContext";

const clearExceptionsSession = () => {
  markExceptionsRouterInactive();
  sessionStorage.removeItem(EXCEPTIONS_FILTERS_SESSION_KEY_OVERVIEW);
  sessionStorage.removeItem(EXCEPTIONS_FILTERS_SESSION_KEY_ARCHIVED);
};

const ExceptionsRouter = (props: RouteComponentProps): JSX.Element => {
  const userContext = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    markExceptionsRouterActive();

    const unlisten = history.listen((location) => {
      if (!location.pathname.startsWith('/exceptions')) {
        clearExceptionsSession();
      }
    });

    return () => {
      unlisten();
      clearExceptionsSession();
    };
  }, [history]);
  if (!userContext.roles.includes(Roles.EXCEPTION_MANAGER)) {
    return <Unauthorized />;
  }
  return (
    <Switch>
      <Route path={`${props.match.path}/view`} component={ExceptionsHome} />
      <Redirect from={props.match.path} to={`${props.match.path}/view`} exact={true} />

      <Route path={`${props.match.path}/create`} component={CreateExceptionsWizard} />
      <Route path={`${props.match.path}/bulk-upload`} component={UploadExceptionsWizard} />
    </Switch>
  );
};

export default ExceptionsRouter;
